module.exports = __webpack_public_path__ + "img/icon32.30866b9b.png";